<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    {{ version }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    computed: {

        version: function() {

			if (this.item.game.version) {

				var version = ''

				version += this.item.game.version.name + ((this.item.game.version.year) ? ' (' + this.item.game.version.year + ')' : '')

				return version

			} else {

				return ''

			}

		}

    }

}

</script>

<style scoped>

</style>